import { render } from "./LocationScanDIalog.vue?vue&type=template&id=059d65ba"
import script from "./LocationScanDIalog.vue?vue&type=script&lang=ts"
export * from "./LocationScanDIalog.vue?vue&type=script&lang=ts"
script.render = render

export default script